import React from "react";
import { Building2, FileText, MapPin, Mail } from "lucide-react";

const ITEMS = [
  {
    icon: Building2,
    label: "Capital social",
    value: "3 000 000 FCFA",
  },
  {
    icon: FileText,
    label: "Registre de commerce",
    value: "CI-ABJ-03-2025-B13-09212",
  },
  {
    icon: MapPin,
    label: "Adresse",
    value: "Abidjan – Treichville, Avenue 13 Rue 40",
  },
  {
    icon: Mail,
    label: "Adresse postale",
    value: "05 BP 1972 Abidjan 05",
  },
];

export default function LegalInfo() {
  return (
    <section id="legal" data-testid="legal-section" className="bg-[#F3F4F6] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="kms-overline mb-4 flex items-center gap-4">
              <span className="font-heading font-black text-sm text-[#D90429]">07</span>
              <span className="h-px w-12 bg-[#D90429]" />
              <span>Informations légales</span>
            </div>
            <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-[#0A1128] leading-[1.05]">
              Transparence et <span className="text-[#D90429]">conformité</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#6B7280]">
            KMS SP SARL exerce ses activités en pleine conformité avec la
            législation ivoirienne.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-gray-200 border border-gray-200">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.label}
                className="bg-white p-8 hover:bg-[#0A1128] hover:text-white transition-colors duration-300 group"
              >
                <Icon size={28} className="text-[#D90429]" />
                <div className="mt-6 text-xs uppercase tracking-[0.2em] text-[#9CA3AF] group-hover:text-white/60">
                  {it.label}
                </div>
                <div className="mt-2 font-heading font-bold text-lg text-[#0A1128] group-hover:text-white leading-tight">
                  {it.value}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
